<template>
  <el-breadcrumb separator=">">
    <el-breadcrumb-item>首页</el-breadcrumb-item>
    <el-breadcrumb-item v-for="(item,index) in list" :key="index">{{item.title}}</el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      // list: JSON.parse(window.sessionStorage.getItem("breadcrumb-list")),
    };
  },
  // 可以在路由导航守卫 里拦截 当前页跳转当前页
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/base/Breadcrumb/index.vue